import { action, computed, IObservableArray, observable } from 'mobx';
import isNil from 'ramda/src/isNil';
import { OfferGroupSortCriteria } from '~client/model/offer-group-sort-criteria';
import { SimpleOfferGroupResponse } from '~client/model/simple-offer-group-response';
import { BaseStore } from '~web/store/base/base-store';

export class OfferGroupsStore extends BaseStore {
  @observable activeOfferWarn: boolean;
  @observable sortCriteria: OfferGroupSortCriteria;
  @observable selectedSectionCodes: IObservableArray<string>;
  @observable offerGroupsHaveMerch: boolean;
  @observable selectedOfferGroup: SimpleOfferGroupResponse;

  constructor() {
    super();
    this.clear();
  }

  @computed get hasSelectedSectionCodes(): boolean {
    return this.selectedSectionCodes && this.selectedSectionCodes.length > 0;
  }

  @action
  showActiveOfferWarn(): void {
    this.activeOfferWarn = true;
  }

  @action
  setSortCriteria(sortCriteria: OfferGroupSortCriteria): void {
    this.sortCriteria = sortCriteria;
  }

  setSelectedOfferGroup(offerGroup: SimpleOfferGroupResponse): void {
    this.selectedOfferGroup = offerGroup;
    if (isNil(offerGroup)) {
      this.activeOfferWarn = false;
    }
  }

  @action
  setSelectedSectionCodes(sectionCodes: string[]): void {
    this.selectedSectionCodes.replace(sectionCodes);
  }

  @action
  clearSelectedSectionCodes(): void {
    this.selectedSectionCodes.clear();
  }
  /**
   * @override
   */
  clear(): void {
    if (this.selectedSectionCodes) {
      this.clearSelectedSectionCodes();
    } else {
      this.selectedSectionCodes = observable.array();
    }
    this.sortCriteria = OfferGroupSortCriteria.QUALIFYING_PRICE;
    this.offerGroupsHaveMerch = false;
    this.selectedOfferGroup = undefined;
  }

  destroy(): void {
    this.clear();
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/web/src/js/store/transaction/offer-groups-store.ts